import { Stack, Title } from '@mantine/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

import DarkModeButton from '../Buttons/DarkModeButton'
// import LanguageButton from '../Buttons/LanguageButton'

interface GeneralPreferencesProps {
  isMobile: boolean
}

const GeneralPreferences: React.FC<GeneralPreferencesProps> = ({ isMobile }) => {
  const { t } = useTranslation()
  // const theme = useMantineTheme()
  return (
    <Stack>
      <Title order={isMobile ? 4 : 3}>
        {t('components.settings.generalPreferences', 'General Preferences')}
      </Title>
      <DarkModeButton />
      {/* <Stack style={{gap:'10px'}}>
        <Text className={classes.text}>{t('components.settings.language', 'Language')}</Text>
        <Text style={{ color: theme.colors.paragraph[0], textAlign: 'left' }}>
          {t('components.settings.languagesBeta', 'Hub translation is currently in Beta')}
        </Text>
        <LanguageButton />
      </Stack> */}
    </Stack>
  )
}

export default GeneralPreferences
